import dayjs from "dayjs"
import { DATE_FORMAT } from "constants"
import { localisedValue } from "utils"

export const userDocumentsTransformer = response => {
  return {
    ...response,
    data: response?.data.map(item => ({
      ...item,
      createdAt: dayjs(item?.createdAt).isValid() ? dayjs(item?.createdAt).format(DATE_FORMAT) : null,
      signedAt: dayjs(item?.signedAt).isValid() ? dayjs(item?.signedAt).format(DATE_FORMAT) : null,
      documentTitle: localisedValue({ object: item, key: "documentTitle" }),
    })),
  }
}
